import React from 'react';
import { Quote } from 'lucide-react';
import FadeIn from './FadeIn';

const testimonials = [
  {
    quote: "Swaram has completely transformed my understanding of Raga Bhavam. The rigorous training in basics gave me a foundation I couldn't find elsewhere.",
    author: "Lakshmi Priya",
    role: "Senior Disciple",
    image: "https://picsum.photos/100/100?random=1"
  },
  {
    quote: "The online classes are structured so beautifully. Despite being in the US, I feel like I am sitting right in front of my Guru in Chennai.",
    author: "Aditya Narayan",
    role: "Intermediate Student",
    image: "https://picsum.photos/100/100?random=2"
  },
  {
    quote: "Learning here is not just about music; it's about discipline, culture, and devotion. The atmosphere is truly divine.",
    author: "Meera Krishnan",
    role: "Parent of Student",
    image: "https://picsum.photos/100/100?random=3"
  }
];

const Testimonials: React.FC = () => {
  return (
    <section id="testimonials" className="py-24 bg-sand/20">
      <div className="max-w-7xl mx-auto px-6">
        <FadeIn className="mb-16 flex flex-col items-center text-center">
            <h2 className="font-display text-4xl text-gray-900 mb-4">Voice of Students</h2>
            <div className="w-16 h-0.5 bg-royal-maroon/40"></div>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((t, idx) => (
            <FadeIn key={idx} delay={idx * 150} className="bg-white p-8 rounded-lg shadow-sm border border-gray-100 flex flex-col items-center text-center relative">
              <div className="absolute top-0 -translate-y-1/2 bg-royal-maroon text-white p-3 rounded-full shadow-lg">
                <Quote size={20} fill="currentColor" />
              </div>
              
              <div className="mt-6 mb-6">
                <p className="text-gray-600 italic font-light leading-relaxed">"{t.quote}"</p>
              </div>
              
              <div className="mt-auto flex items-center gap-4">
                <img 
                    src={t.image} 
                    alt={t.author} 
                    className="w-12 h-12 rounded-full object-cover border-2 border-sand"
                />
                <div className="text-left">
                    <p className="font-display text-lg text-gray-900">{t.author}</p>
                    <p className="text-xs text-royal-maroon uppercase tracking-wider">{t.role}</p>
                </div>
              </div>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;